/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ChildPacifierIcon16Light } from './ChildPacifierIcon16Light';
import { ChildPacifierIcon16Regular } from './ChildPacifierIcon16Regular';
import { ChildPacifierIcon16Solid } from './ChildPacifierIcon16Solid';
import { ChildPacifierIcon20Light } from './ChildPacifierIcon20Light';
import { ChildPacifierIcon20Regular } from './ChildPacifierIcon20Regular';
import { ChildPacifierIcon20Solid } from './ChildPacifierIcon20Solid';
import { ChildPacifierIcon24Regular } from './ChildPacifierIcon24Regular';
import { ChildPacifierIcon24Solid } from './ChildPacifierIcon24Solid';
import { ChildPacifierIcon32Regular } from './ChildPacifierIcon32Regular';
import { ChildPacifierIcon64Regular } from './ChildPacifierIcon64Regular';
var sizes = {
    16: {
        light: ChildPacifierIcon16Light,
        regular: ChildPacifierIcon16Regular,
        solid: ChildPacifierIcon16Solid,
    },
    20: {
        light: ChildPacifierIcon20Light,
        regular: ChildPacifierIcon20Regular,
        solid: ChildPacifierIcon20Solid,
    },
    24: {
        regular: ChildPacifierIcon24Regular,
        solid: ChildPacifierIcon24Solid,
    },
    32: {
        regular: ChildPacifierIcon32Regular,
    },
    64: {
        regular: ChildPacifierIcon64Regular,
    },
};
export var ChildPacifierIcon = forwardRef('ChildPacifierIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
